"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StableCoin__factory = exports.MockSavingsVault__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var MockSavingsVault__factory_1 = require("./MockSavingsVault__factory");
Object.defineProperty(exports, "MockSavingsVault__factory", { enumerable: true, get: function () { return MockSavingsVault__factory_1.MockSavingsVault__factory; } });
var StableCoin__factory_1 = require("./StableCoin__factory");
Object.defineProperty(exports, "StableCoin__factory", { enumerable: true, get: function () { return StableCoin__factory_1.StableCoin__factory; } });
